import type { ReactNode } from 'react'

interface PlayerCardProps {
  children: ReactNode
  isFlipped: boolean
  onFlip: () => void
}

export function PlayerCard({ children, isFlipped, onFlip }: PlayerCardProps) {
  const handleCardClick = (event: React.MouseEvent<HTMLDivElement>) => {
    if ((event.target as HTMLElement).closest('button, select, input, label')) return
    onFlip()
  }

  return (
    <div
      className={`player-card ${isFlipped ? 'flipped' : ''}`}
      role="button"
      tabIndex={0}
      onClick={handleCardClick}
      onKeyDown={event => {
        if (event.target !== event.currentTarget) return
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault()
          onFlip()
        }
      }}
    >
      <div className="player-card-inner">{children}</div>
      <button className="flip-trigger" onClick={event => { event.stopPropagation(); onFlip() }} aria-label={isFlipped ? 'Show front of card' : 'Show back of card'} />
    </div>
  )
}